module.exports = __webpack_public_path__ + "media/components/assets/img/bg/booking-fields-60ad524495d7ce762a759d229953bd31.svg";